import { Builder } from '@builder.io/react';
import Table from './table';

const defaultContent = {
  '@type': '@builder.io/sdk:Element',
  component: {
    name: 'Text',
    options: {
      text: '<p>Enter some text...</p>',
    },
  },
};

Builder.registerComponent(Table, {
  name: 'Table',
  static: true,
  inputs: [
    {
      name: 'columns',
      type: 'list',
      subFields: [
        {
          name: 'label',
          type: 'string',
          required: true,
          autofocus: true,
          defaultValue: 'Column label',
        },
        {
          name: 'textAlign',
          type: 'string',
          required: true,
          enum: [
            'start',
            'center',
            'end',
            'justify',
            'justify-all',
            'match-parent',
          ],
          defaultValue: 'start',
        },
      ],
      defaultValue: [
        {
          label: 'Col 1',
          textAlign: 'start',
        },
        {
          label: 'Col 2',
          textAlign: 'start',
        },
      ],
    },
    {
      name: 'rows',
      type: 'list',
      subFields: [
        {
          name: 'columns',
          type: 'list',
          subFields: [
            {
              name: 'content',
              type: 'uiBlocks',
              hideFromUI: true,
              defaultValue: [defaultContent],
            },
          ],
          defaultValue: [{ content: [defaultContent] }],
        },
      ],
      defaultValue: [{ columns: [{ content: [defaultContent] }] }],
    },
  ],
});
